import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PersonalParticularOldState } from '../reducers/personal-particular-old.reducers';

export const selectPersonalParticularFeature = createFeatureSelector<PersonalParticularOldState>('personalParticularOld');

export const selectFeaturePersonalParticularDetail = createSelector(selectPersonalParticularFeature, (state: PersonalParticularOldState) => state.detail);
